import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { ICogsList } from '~/utils/interface/cogs';
import { handleGetCogsList } from './cogsThunk';

export interface CogsState {
  selectCogs: Array<ICogsList>;
  filterCogs: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshDataCogs: boolean;
  cogs: Array<ICogsList>;
  selectedIdsCogs: Array<string>;
  cogsId: string;
  openAlertDeleteCogs: boolean;
  menuSelectedIdCogs: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: CogsState = {
  selectCogs: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshDataCogs: false,
  filterCogs: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIdsCogs: [],
  cogs: [],
  cogsId: '',
  openAlertDeleteCogs: false,
  menuSelectedIdCogs: undefined,
};

const cogsSlice = createSlice({
  name: 'cogs',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshDataCogs = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filterCogs = { ...state.filterCogs, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIdsCogs = [...action.payload];
    },
    changeCogsId(state, action: PayloadAction<string>) {
      state.cogsId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDeleteCogs = action.payload;
      if (!state.openAlertDeleteCogs) {
        state.menuSelectedIdCogs = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedIdCogs = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetCogsList.pending, (_state, _action) => {})

      .addCase(handleGetCogsList.fulfilled, (state, action) => {
        state.cogs = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshDataCogs = false;
      })

      .addCase(handleGetCogsList.rejected, (_state, _action) => {});
  },
});

export const cogsActions = cogsSlice.actions;

const cogsReducer = cogsSlice.reducer;
export default cogsReducer;
